import { inApp } from '@inv/base/es/platform'
import i18next, { InitOptions, TFunction } from 'i18next'
import { initReactI18next } from 'react-i18next'
import { firstLetterUpper } from '@inv/utils/es/caseTransform'
import { DEFAULT_LOCALE } from '@const/i18n'
import { getLocale } from '@helper/common/utils/locale'

const LANG = inApp ? getLocale() : DEFAULT_LOCALE
const getI18nConfig = (resources: any): InitOptions => ({
  defaultNS: 'common',
  keySeparator: false,
  debug: process.env.NODE_ENV === 'development',
  interpolation: {
    escapeValue: false
  },
  resources,
  react: {
    bindI18n: 'languageChanged loaded',
    bindI18nStore: 'added removed',
    nsMode: 'default',
    useSuspense: false
  },
  lng: LANG,
  fallbackLng: 'en',
  load: 'currentOnly'
})

export const changeLanguage = (locale: string) => {
  i18next.changeLanguage(locale)
}

// Uppercase the first letter of every word. abcd => Abcd or abcd efg => Abcd Efg
export const tUpper = (str: string, allWords = true, options?: any): string =>
  firstLetterUpper(i18next.t(str, options) as unknown as string, allWords)

// Uppercase all letters. abcd => ABCD
export const tUpperCase = (str: string): string => i18next.t(str).toUpperCase()
export const tLowerCase = (
  transifyKey: Parameters<TFunction>[0],
  options: Parameters<TFunction>[1]
): string => i18next.t(transifyKey, options).toLowerCase()

export const loadResource = (lng: string, data: any) => {
  i18next.addResourceBundle(lng, 'common', data)
  changeLanguage(lng)
}

export const importLocale = async (locale: string) => {
  if (!window.languages) {
    const { default: resources } = await import(`../../i18n/locales/${locale ?? 'en'}.json`)
    // eslint-disable-next-line require-atomic-updates
    window.languages = { [locale]: { common: resources } }
  }
  return window.languages
}

export const initI18n = async () => {
  try {
    const resources = await importLocale(LANG)
    i18next.use(initReactI18next).init(getI18nConfig(resources))
  } catch (err) {
    console.log('err', err)
  }
}

export default i18next
